import React from "react";

export default function MessageBar(props) {
  return (
    <div
      className={`flex items-center gap-x-4 p-4 ${props.background} border-2 ${props.border} rounded-md w-fit mt-5`}
    >
      <div className={`${props.imgback} rounded-lg p-2`}>
        <img
          src={`images/messageBar/${props.image}.webp`}
          alt="succes"
          className="sm:max-w-[24px] max-w-[20px]"
        />
      </div>
      <p className="font-normal sm:text-base text-sm leading-4 text-black">{props.text}</p>
    </div>
  );
}
